import type {ReactElement} from 'react';
import {FontSizeControl} from '@FormMakerReact/layout/form-maker-right-panel/controls/font-size-control/font-size-control';
import {DESCRIPTION_SIZES} from '@FormMakerReact/layout/form-maker-right-panel/sectors/description-sector/description-sector.types';
import type {DescriptionSizeControlProps} from './description-size-control.types';

export function DescriptionSizeControl({component}: DescriptionSizeControlProps): ReactElement {
  return <FontSizeControl component={component} sizes={DESCRIPTION_SIZES} />;
}